// extracted by mini-css-extract-plugin
export default {"container":"style_container__p-pvc","titleSection":"style_titleSection__2bP+8"};